import { useCallback, useEffect, useState } from "react";
import "./UserInfo.css";
import defaultProfile from "../../images/profile.png";
import { fetchUserBasicInfo } from "../../services/UserService";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../hooks/useUser";

const UserInfo = ({ userId, comment = false,closeOnClickUser=false,userData}) => {
  const { user: me } = useUser();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({ profilePhoto: null, userName: null,fullName:null });
  const navigate = useNavigate();

const getUserBasicInfo = useCallback(async () => {
    try {
      if (userId === me.userId) {
        return setUser({ profilePhoto: me.profilePhoto, userName: "You", fullName:me.fullName });
      }
      const fetchedUser = await fetchUserBasicInfo(userId);
      setUser(fetchedUser);
    } catch (error) {
      console.error(error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [userId, me.userId, me.profilePhoto,me.fullName]);

  const handleUserClick = () => {
    navigate(`/profile/${userId}`);
    if(closeOnClickUser)
      closeOnClickUser();
  };

  useEffect(() => {
  if (!userData) {
    getUserBasicInfo(); 
  } else {
    setUser({ profilePhoto: userData?.profilePhoto, userName: userData?.userName, fullName:userData?.fullName});
    setLoading(false);
  }
}, [getUserBasicInfo,userData]);

  return (
    <div className="user-basic-info" onClick={handleUserClick}>
      <div className="profile-photo">
        <img
          src={user.profilePhoto ? user.profilePhoto.url : defaultProfile}
          alt=""
        />
      </div>
      <div>
        <h5 className="username">
          {loading
            ? "Loading ..."
            : user.userName
            ? user.userName
            : "not found"}
        </h5>
        {!loading&&!comment&&<p>{user.fullName}</p>}
        {comment &&  <p className="user-comment">{comment}</p>}
      </div>
    </div>
  );
};

export default UserInfo;
